import { ContactResponse } from "./type";

export const ContactApi = {
  async getContact() {
    return {
      status: 0,
      msg: "Success",
      data: [
        {
          id: "1",
          Platform: "Telegram",
          URL: "https://t.me/TK88_Support",
        },
        {
          id: "2",
          Platform: "LiveChat",
          URL: "https://tawk.to",
        },
      ],
    } as ContactResponse;
  },
};
